<!--
 * @Author: your name
 * @Date: 2021-03-10 11:22:29
 * @LastEditTime: 2021-08-06 09:56:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_web\src\views\Main.vue
-->
<template>
  <div class="mook-home">
    <el-row class="mook-header">
      <el-col class="layout_center logo">
        <img v-if="lange == 'Ch'" class="auto-img" src="@/assets/logo_ch.png" />
        <img v-else class="auto-img" src="@/assets/logo_jpn.png" />
      </el-col>
      <div class="on_JPN" v-if="lange == 'Ch'" @click="onJPN">日文版</div>
      <!-- <el-dropdown class="layout_vertica_center" @command="changeLange" trigger="click">
        <span class="el-dropdown-link">
          {{langeName}}
          <i class="el-icon-caret-bottom el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="lang_dropdown">
          <el-dropdown-item
            :class="item.active?'dropdown-active':''"
            v-for="(item,index) in langeList"
            :key="index"
            v-text="item.name"
            :command="index"
          ></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <div class="nav_dropdown layout_vertica_center">
        <div class="el-dropdown-link" @click="drawer = true">
          <img class="auto-img" src="@/assets/icon/menu.png" />
        </div>
      </div>

      <!-- 移动端导航菜单 -->
      <el-drawer
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        :size="'100%'"
        class="phone"
      >
        <div class="nav-menu">
          <el-menu
            :default-active="defaultActive"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @select="selectOption"
            text-color="#3E3A39"
            active-text-color="#876D4B"
          >
            <template v-for="(item, index) in navData">
              <el-submenu
                v-if="
                  item.name == 'Product' ||
                  item.name == 'StarItem' ||
                  item.name == 'Introduce'
                "
                :index="String(index)"
                :key="index"
              >
                <template slot="title">
                  <span>{{ item.tit }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    v-for="(val, i) in item.dropdownMenu"
                    :key="val.name"
                    :index="String(index + '-' + i)"
                    >{{ val.title }}</el-menu-item
                  >
                </el-menu-item-group>
              </el-submenu>
              <el-menu-item :key="index" :index="String(index)" v-else>
                <span slot="title">{{ item.tit }}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </div>
      </el-drawer>
    </el-row>
    <router-view class="phone"></router-view>
    <!-- web端导航菜单 -->
    <el-row class="nav-tabs web">
      <el-tabs v-model="activeName" @tab-click="switchNav">
        <router-view></router-view>
        <template v-for="(item, index) in navData">
          <el-tab-pane
            v-if="
              item.name != 'Product' &&
              item.name != 'StarItem' &&
              item.name != 'Introduce'
            "
            :label="item.tit"
            :name="item.name"
            :key="index"
          ></el-tab-pane>
          <el-tab-pane v-else :key="item.name">
            <span slot="label">
              <el-dropdown
                placement="bottom"
                @command="handleCommand"
                trigger="hover"
              >
                <span>{{ item.tit }}</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :class="val.active ? 'dropdown-active' : ''"
                    v-for="(val, i) in item.dropdownMenu"
                    :key="i"
                    :command="[index, i]"
                    >{{ val.title }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </el-tab-pane>
        </template>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>
import Vue from "vue";
import { categoryList } from "@/api/api";
export default {
  name: "Main",
  data() {
    return {
      defaultActive: "0",
      lastActive: "",
      searchV: "",
      searchData: {},
      selected: "",
      navData: [],
      langeList: [],
      langeType: "",
      langeName: "",
      drawer: false,
      navIndex: 0,
      direction: "ttb",
      activeName: "Home",
      productId: null,
    };
  },
  created() {
    this.langeType = this.lange;
    let lange = "";
    // let lange =
    //   JSON.parse(window.localStorage.getItem("lange")) ||
    //   window.localStorage.getItem("lange");
    if (!lange) lange = this.lange;
    this.switchLange(lange);

    this.activeName = this.navData[0].name;
    this.monitorRouter(this.$route.path, this.$route);
    // if (this.lange == "Ch") {
    //   this.langeList = [
    //     { name: "中文", type: "Ch", active: true },
    //     { name: "日文", type: "JPN", active: false },
    //   ];
    // } else {
    //   this.langeList = [
    //     { name: "JPN", type: "JPN", active: true },
    //     { name: "CH", type: "Ch", active: false },
    //   ];
    // }

    if (!lange || lange == "undefined") {
      window.localStorage.setItem("lange", JSON.stringify(this.lange));
    } else {
      this.langeList.forEach((v, index) => {
        if (v.type == lange) {
          this.changeLange(index);
          Vue.prototype.lange = this.langeList[index].type;
        }
      });
    }
    if (
      this.navData[1].dropdownMenu &&
      this.navData[1].dropdownMenu.length <= 0
    )
      this.getProductList();
  },
  methods: {
    // 导航切换meth
    switchNav(tab) {
      let index = tab.index;
      this.navIndex = index;
      const name = this.navData[this.navIndex].name;
      switch (name) {
        case "Product":
          this.activeName = "1";
          this.checkDropdown(index);
          break;
        case "StarItem":
          this.activeName = "2";
           this.checkDropdown(index);
          break;
        case "Introduce":
          this.activeName = index;//"5";
           this.checkDropdown(index);
          break;
        default:
          this.activeName = name;
          if (tab.name) this.$router.push({ name: tab.name });
          break;
      }
    },
  checkDropdown(index){
    let navItem=this.navData[index];
    if(navItem.dropdownMenu && navItem.dropdownMenu.length==1){
      this.handleCommand([index,0]);
    }
  },
    // 日本官网
    onJPN() {
      window.location.href = "http://www.mooklook.jp/";
    },
    // 一键切换
    changeLange(index) {

      const lange =
        JSON.parse(window.localStorage.getItem("lange")) ||
        window.localStorage.getItem("lange");
      this.langeName = this.langeList[index].name;
      if (this.langeList[index].active) return;
      let lastIndex = index == 0 ? 1 : 0;
      this.langeList[index].active = true;
      this.langeList[lastIndex].active = false;
      if (this.langeList[index].type == "JPN" && this.langeType == "Ch") {
        this.langeList = [
          { name: "CH", type: "Ch", active: false },
          { name: "JPN", type: "JPN", active: true },
        ];
        this.langeName = this.langeList[index].name;
      }

      if (this.langeList[index].type != lange) {
        let hash = window.location.hash.split("?");
        if (hash[1]) window.location.href = window.location.origin;
        else location.reload();
      }

      window.localStorage.setItem(
        "lange",
        JSON.stringify(this.langeList[index].type)
      );
    },
    // 切换语言
    switchLange(lange) {
      switch (lange) {
        case "JPN":
          this.navData = [
            // { name: "Home", tit: "最初のページ" },
            // { name: "Product", tit: "シリーズ", dropdownMenu: [] },
            // { name: "StarItem", tit: "スター単品", dropdownMenu: [] },
            // { name: "AOG", tit: "AOG特許" },
            // { name: "BrandNews", tit: "ブランド動態" },
            // { name: "Introduce", tit: "ブランド紹介", dropdownMenu: [] },
            // { name: "AboutUs", tit: "連絡します" },
            { name: "Home", tit: "TOP" },
            { name: "Product", tit: "PRODUCTS", dropdownMenu: [] },
            { name: "StarItem", tit: "PICK UP", dropdownMenu: [] },
            { name: "AOG", tit: "TECHNOLOGY" },
            // { name: "BrandNews", tit: "BRANd NEWS" },
            { name: "Introduce", tit: "ABOUT", dropdownMenu: [] },
            { name: "AboutUs", tit: "CONTACT" },
          ];
          // if (this.langeType == "JPN") {
          //   this.navData.splice(4,1);
          // }
          this.activeName = "Home";
          break;
        default:
          this.navData = [
            { name: "Home", tit: "首页" },
            {
              name: "Product",
              tit: "产品系列",
              dropdownMenu: [],
            },
            {
              name: "StarItem",
              tit: "明星单品",
              dropdownMenu: [
                { title: "精华有", active: false },
                { title: "胶囊水", active: false },
                { title: "小灯管", active: false },
                { title: "时尚面霜", active: false },
              ],
            },
            { name: "AOG", tit: "AOG专利" },
            { name: "BrandNews", tit: "品牌动态" },
            {
              name: "Introduce",
              tit: "品牌介绍",
              dropdownMenu: [],
            },
            { name: "AboutUs", tit: "联系我们" },
          ];
          // if (this.langeType == "JPN") {
          //   this.navData = [
          //     { name: "Home", tit: "首页" },
          //     {
          //       name: "Product",
          //       tit: "产品系列",
          //       dropdownMenu: [],
          //     },
          //     {
          //       name: "StarItem",
          //       tit: "明星单品",
          //       dropdownMenu: [],
          //     },
          //     { name: "AboutUs", tit: "联系我们" },
          //   ];
          // }
          this.activeName = "Home";
      }
    },
    monitorRouter(path, to) {
      let activeIndex = to && to.query.index;
      switch (path) {
        case "/product":
          this.activeName = "1";
          this.defaultActive = activeIndex;
          break;
        case "/starItem":
          this.activeName = "2";
          this.defaultActive = activeIndex;
          break;
        case "/brandNews":
          this.activeName = "BrandNews";
          this.defaultActive = "4";
          break;
        case "/detail":
          this.activeName = "BrandNews";
          break;
        case "/Introduce":
          this.activeName = "5";
          this.defaultActive = activeIndex;
          break;
        case "/patent":
          this.activeName = "AOG";
          this.defaultActive = "3";
          break;
        case "/aboutUs":
          this.activeName = "AboutUs";
          this.defaultActive = "6";
          break;
        default:
          this.activeName = "Home";
          this.defaultActive = "0";
      }
      if(this.lange=="JPN" && path=="/Introduce"){
         this.activeName = "4";
      }

    },
    // 产品系列菜单栏
    getProductList() {
      categoryList({ lang: this.lange == "JPN" ? "ja_JP" : "" }).then((res) => {
        if (res.data.code == 0) {
          // 产品系列
          let dropdownMenu = res.data.data[0] && res.data.data[0].childrens;
          // 明星单品
          let starItem = res.data.data[1] && res.data.data[1].childrens;
          // 品牌介绍
          let Introduce = res.data.data[2] && res.data.data[2].childrens;
          dropdownMenu.forEach((v) => (v.active = false));
          // 产品系列
          this.navData[1].dropdownMenu = dropdownMenu;
          this.navData[2].dropdownMenu = starItem;
          this.navData[this.lange == "JPN"?4:5].dropdownMenu = Introduce;
        }
      });
    },
    handleClose(done) {
      done();
    },
    // 侧边栏选择
    async selectOption(key, keyPath) {

      this.defaultActive = key;
      const data = this.navData[keyPath[0]];
      switch (this.navData[keyPath[0]].name) {
        case "Product":
          this.handleCommand([
            Number(keyPath[1].split("-")[0]),
            Number(keyPath[1].split("-")[1]),
          ]);
          break;
        case "StarItem":
          this.handleCommand([
            Number(keyPath[1].split("-")[0]),
            Number(keyPath[1].split("-")[1]),
          ]);
          break;
        case "Introduce":
          this.handleCommand([
            Number(keyPath[1].split("-")[0]),
            Number(keyPath[1].split("-")[1]),
          ]);
          break;
        default:
          this.$router.push({ name: this.navData[keyPath[0]].name });
          break;
      }
      this.drawer = false;
    },
    // 菜单展开
    handleOpen(key, keyPath) {
      const name = this.navData[keyPath[0]].name;
      switch (name) {
        case "Product":
          break;
      }
    },
    // 点击选择
    handleCommand(index) {
      let navData = this.navData[index[0]].dropdownMenu;
      index[0] = this.lange == "JPN" && index[0]==4?5:index[0];
      navData.forEach((v) => (v.active = false));
      navData[index[1]].active = true;
      switch (index[0]) {
        case 1:
          this.$router.push({
            name: "Product",
            query: {
              id: navData[index[1]].id,
              detail: JSON.stringify(navData[index[1]]),
              index: `${index[0]}-${index[1]}`,
            },
          });
          break;
        case 2:
          this.StarTitle = navData[index[1]].title;
          this.$router.push({
            name: "StarItem",
            query: {
              id: navData[index[1]].id,
              detail: JSON.stringify(navData[index[1]]),
              index: `${index[0]}-${index[1]}`,
            },
          });
          break;
        case 5:
          this.$router.push({
            name: "Introduce",
            query: {
              id: navData[index[1]].id,
              detail: JSON.stringify(navData[index[1]]),
              index: `${index[0]}-${index[1]}`,
            },
          });
          break;
      }
    },
  },
  watch: {
    $route(to, from) {
      // from.path 从哪来
      // to.path 到哪去
      this.monitorRouter(to.path, to);
    },
  },
};
</script>
<style lang="less" scoped>
.mook-home {
  width: 100%;
  .mook-header {
    position: relative;
    max-width: 1440px;
  min-width: 1240px;
    margin: 0 auto;
    .on_JPN {
      width: 48px;
      height: 22px;
      border: 1px solid #876d4b;
      color: #876d4b;
      text-align: center;
      line-height: 22px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      cursor: pointer;
    }
    .lange_box {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      font-size: 20px;
      .lange {
        padding: 0 5px;
        color: #878787;
      }
      .active {
        font-weight: bold;
        color: #000;
      }
      .line {
        border: 1px solid #ddd;
        height: 20rem;
      }
    }
    .nav_dropdown {
      width: 17.5px;
      right: 16px;
    }
    // 移动端菜单
    .nav-menu {
      .el-menu {
        min-width: 30%;
        border: none;
        font-family: "SOURCEHANSANSCN";
        .el-menu-item-group {
          color: #878787 !important;
          font-size: 10px;
        }
        /deep/.is-active {
          .el-submenu__title {
            color: #876d4b !important;
          }
        }

        /deep/.is-active,
        /deep/&-item:hover {
          background-color: #fff;
          color: #876d4b !important;
          font-weight: bold;
        }

        /deep/.el-submenu__title {
          i {
            color: #3e3a39;
            font-weight: bold;
            line-height: 18px;
          }
          span {
            margin-right: 10px;
          }
        }
        /deep/&-item {
          padding: 0;
        }
        /deep/.el-submenu {
          &__icon-arrow {
            right: auto;
          }
          .el-menu-item {
            font-size: 10px;
            color: #878787 !important;
          }
          .is-active {
            color: #876d4b !important;
          }
        }

        /deep/.el-menu-item-group__title {
          padding: 0;
        }
        > .is-active {
          /deep/i {
            color: #876d4b !important;
          }
        }
      }
    }
  }
  // web端菜单
  .nav-tabs {
    /deep/.el-tabs__nav {
      position: relative;
      left: 50%;
      transform: translateX(-50%) !important;

    }

    /deep/.el-tabs__nav-wrap::after {
      height: 0;
    }
    /deep/.el-tabs {
      .is-active {
        color: #876d4b !important;
        .el-dropdown {
          color: #876d4b;
        }
      }
      &--top {
        .is-top:nth-child(2) {
          // padding-left: 81px;
        }
      }
      &__item {
        padding: 0 41px 10px;
        font-size: 20px;
        font-weight: 400;
        color: #212121;
        font-family: "SOURCEHANSANSCN";
      }
      .el-dropdown {
        font-size: 20px;
      }
      &__active-bar {
        background-color: #876d4b;
      }
      &__item:hover {
        color: #876d4b;
      }
    }
  }
}
</style>
